/* The Cart Room — interaction layer. No dependencies. Everything here is decoration:
   the page works exactly the same with JS off. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover)').matches;

  /* 1. Hero mascot. The eye slits are the logo's own shapes; the expression system
     signed off on the concept board:
     - a dead zone around centre where the face is exactly the resting logo
       (no pupils, no morph) — "not looking anywhere" is a region, not a pixel;
     - beyond it, both slits open wide the SAME way whether you look up or down
       (shape says how far, the pupil says which way);
     - pupils are dots clipped inside the slits, radius 0 at rest, growing with
       distance so they fade in instead of popping. */
  function initMascot() {
    var mascot = document.querySelector('.cr-hero__mascot');
    if (!mascot) return;
    var look = mascot.querySelector('.cr-hero__look');
    var eyeL = mascot.querySelector('.cr-eye--l'), eyeR = mascot.querySelector('.cr-eye--r');
    var clipL = mascot.querySelector('.cr-eyec--l'), clipR = mascot.querySelector('.cr-eyec--r');
    var pupL = mascot.querySelector('.cr-pupil--l'), pupR = mascot.querySelector('.cr-pupil--r');

    function quad(oX, iX, cO, hO, cI, hI) {
      return 'M' + oX + ' ' + (cO - hO).toFixed(1) +
             ' L' + iX + ' ' + (cI - hI).toFixed(1) +
             ' L' + iX + ' ' + (cI + hI).toFixed(1) +
             ' L' + oX + ' ' + (cO + hO).toFixed(1) + ' Z';
    }

    function setEyes(rawDx, rawDy) {
      if (!eyeL || !eyeR || !look) return;
      /* dead zone: inner 28% of the range = fully at rest */
      var dist = Math.hypot(rawDx, rawDy) || 1e-9;
      var t = Math.max(0, Math.min(1, (dist - 0.28) / 0.72));
      var k = t / dist, dx = rawDx * k, dy = rawDy * k;
      /* symmetric morph: reacts to how far you look, not which way vertically */
      var m = Math.abs(dy);
      var tilt = 20 - m * 22 * (1 - Math.abs(dx) * 0.45);
      var open = 1 + m * 0.5;
      var oL = open * (1 - dx * 0.08), oR = open * (1 + dx * 0.08);
      var cI0 = 162 + tilt * 0.85;
      var dL = quad(112, 158, 162, 14 * oL, cI0, 11 * oL);
      var dR = quad(208, 162, 162, 14 * oR, cI0, 11 * oR);
      eyeL.setAttribute('d', dL); eyeR.setAttribute('d', dR);
      if (clipL && clipR) { clipL.setAttribute('d', dL); clipR.setAttribute('d', dR); }
      if (pupL && pupR) {
        var pr = (8 * Math.min(1, t * 1.7)).toFixed(1);
        var yC = (162 + cI0) / 2 + dy * 5.5;
        pupL.setAttribute('cx', (135 + dx * 10).toFixed(1)); pupL.setAttribute('cy', yC.toFixed(1)); pupL.setAttribute('r', pr);
        pupR.setAttribute('cx', (185 + dx * 10).toFixed(1)); pupR.setAttribute('cy', yC.toFixed(1)); pupR.setAttribute('r', pr);
      }
      look.setAttribute('transform', 'translate(' + (dx * 18).toFixed(1) + ' ' + (dy * 12).toFixed(1) + ')');
    }

    if (!reduceMotion) {
      if (canHover) {
        var raf = null, mx = 0, my = 0;
        window.addEventListener('mousemove', function (e) {
          mx = e.clientX; my = e.clientY;
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            var r = mascot.getBoundingClientRect();
            var dx = Math.max(-1, Math.min(1, (mx - (r.left + r.width / 2)) / 300));
            var dy = Math.max(-1, Math.min(1, (my - (r.top + r.height * 0.45)) / 240));
            setEyes(dx, dy);
          });
        }, { passive: true });
      } else {
        /* no cursor to follow: cycle through little expressions, resting in between */
        var seq = [[0.7, -0.5], [0, 0], [-0.7, 0.5], [0.8, 0.4], [0, 0], [0, -0.9]];
        var cur = { x: 0, y: 0 }, step = -1;
        setInterval(function () {
          var target = seq[step = (step + 1) % seq.length];
          var from = { x: cur.x, y: cur.y }, t0 = null;
          function tween(ts) {
            if (t0 === null) t0 = ts;
            var p = Math.min(1, (ts - t0) / 600);
            p = 1 - Math.pow(1 - p, 3);
            cur.x = from.x + (target[0] - from.x) * p;
            cur.y = from.y + (target[1] - from.y) * p;
            setEyes(cur.x, cur.y);
            if (p < 1) requestAnimationFrame(tween);
          }
          requestAnimationFrame(tween);
        }, 2600);
      }
    }

    mascot.addEventListener('click', function () {
      if (reduceMotion) return;
      mascot.classList.remove('is-wiggling');
      void mascot.offsetWidth; // restart the animation
      mascot.classList.add('is-wiggling');
    });
    mascot.addEventListener('animationend', function (e) {
      if (e.animationName === 'cr-wiggle') mascot.classList.remove('is-wiggling');
    });
  }

  /* 2. Basket pill bumps whenever the cart contents change (Origin re-renders the bubble). */
  function initBasketBump() {
    var pill = document.getElementById('cart-icon-bubble');
    if (!pill || !('MutationObserver' in window)) return;
    var last = pill.textContent.trim();
    new MutationObserver(function () {
      var now = pill.textContent.trim();
      if (now === last) return;
      last = now;
      if (reduceMotion) return;
      pill.classList.remove('is-bumping');
      void pill.offsetWidth;
      pill.classList.add('is-bumping');
    }).observe(pill, { childList: true, subtree: true, characterData: true });
    pill.addEventListener('animationend', function () { pill.classList.remove('is-bumping'); });
  }

  /* 3. Section titles and big stickers "stamp" into place as they scroll in. */
  function initStamps() {
    var els = document.querySelectorAll('.cr-section__title, .cr-colhead__title, .cr-join__title, .cr-dl, .cr-receipt, .cr-eyebrow');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cr-stamp', 'is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.2 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      el.classList.add('cr-stamp');
      // already on screen at load: settle immediately, never hide first-paint content
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in'); else io.observe(el);
    });
  }

  /* 4. Deal countdown: nudge a digit when it changes. */
  function initTimerTicks() {
    var timers = document.querySelectorAll('[data-cr-timer]');
    if (!timers.length || reduceMotion || !('MutationObserver' in window)) return;
    timers.forEach(function (t) {
      t.querySelectorAll('.cr-timer__num').forEach(function (num) {
        new MutationObserver(function () {
          num.classList.remove('is-tick'); void num.offsetWidth; num.classList.add('is-tick');
        }).observe(num, { childList: true, characterData: true, subtree: true });
      });
    });
  }


  /* 5. Nicknames. Every department label is a .cr-flip (snippets/cart-room-dept-name.liquid):
     the real title and an aria-hidden nickname sticker in one grid cell. This schedules the
     swaps so the page feels alive without blinking in unison:
     - each group (header strip, departments grid, scrolling strip, phone menu) flips at most
       a couple of labels at once, picked at random, held 2.5–4s, then put back, then rested 9s;
     - the switch is weighted: shake & pop (CSS) most of the time, typewriter and scramble
       (JS text edits) now and then, and never two text-churn effects at the same moment;
     - the collection H1 is in the same rotation, just on a slower clock. */
  function initNicknames() {
    if (reduceMotion) return;
    var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ&!?#';
    var textBusy = 0;
    function rnd(lo, hi) { return lo + Math.random() * (hi - lo); }
    function caret() { var c = document.createElement('span'); c.className = 'cr-caret'; c.textContent = '|'; return c; }
    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    function runPop(f, toB) {
      var fit = f.classList.contains('cr-flip--fit');
      return new Promise(function (res) {
        /* a fitted flip (the collection H1) eases its box to the incoming word first so the count badge
           settles before the word lands; the CSS delays the incoming word by the same 0.45s */
        if (fit) { var to = f.querySelector(toB ? '.cr-flip__b' : '.cr-flip__a'); f.style.setProperty('--cr-w', to.getBoundingClientRect().width + 'px'); }
        f.classList.remove('is-b'); f.classList.add(toB ? 'cr-go-pop' : 'cr-back-pop');
        setTimeout(function () { f.classList.remove('cr-go-pop', 'cr-back-pop'); f.classList.toggle('is-b', toB); res(); }, fit ? 1050 : 720);
      });
    }
    function runType(f, toB) {
      var fa = f.querySelector('.cr-flip__a'), fb = f.querySelector('.cr-flip__b');
      var from = toB ? fa : fb, to = toB ? fb : fa, src = from.textContent, dst = to.textContent;
      textBusy++;
      return new Promise(function (res) {
        var i = src.length; from.style.opacity = 1; to.style.opacity = 0;
        var del = setInterval(function () {
          i--; from.textContent = src.slice(0, i); if (i > 0) from.appendChild(caret());
          if (i <= 0) {
            clearInterval(del); from.textContent = ''; from.style.opacity = 0; to.style.opacity = 1; to.textContent = '';
            var j = 0; var typ = setInterval(function () {
              j++; to.textContent = dst.slice(0, j); if (j < dst.length) to.appendChild(caret());
              if (j >= dst.length) { clearInterval(typ); to.textContent = dst; from.textContent = src; done(); }
            }, 55);
          }
        }, 40);
        function done() { fa.style.opacity = ''; fb.style.opacity = ''; f.classList.toggle('is-b', toB); textBusy--; res(); }
      });
    }
    function runScramble(f, toB) {
      var fa = f.querySelector('.cr-flip__a'), fb = f.querySelector('.cr-flip__b');
      var from = toB ? fa : fb, to = toB ? fb : fa, dst = to.textContent, n = dst.length, t = 0;
      textBusy++;
      return new Promise(function (res) {
        from.style.opacity = 0; to.style.opacity = 1;
        var iv = setInterval(function () {
          t++; var out = '';
          for (var k = 0; k < n; k++) out += (k < t - 3) ? dst[k] : (dst[k] === ' ' ? ' ' : CHARS[Math.floor(Math.random() * CHARS.length)]);
          to.textContent = out;
          if (t - 3 >= n) { clearInterval(iv); to.textContent = dst; fa.style.opacity = ''; fb.style.opacity = ''; f.classList.toggle('is-b', toB); textBusy--; res(); }
        }, 45);
      });
    }
    /* the fitted collection title types: letters are deleted then typed, and after every letter the box is
       re-measured to the visible text, so the count badge is pulled back and pushed out by the letters
       themselves — no box moving ahead of the word */
    function runTypeFit(f, toB) {
      var fa = f.querySelector('.cr-flip__a'), fb = f.querySelector('.cr-flip__b');
      var from = toB ? fa : fb, to = toB ? fb : fa, src = from.textContent, dst = to.textContent;
      var measure = function (el) { f.style.setProperty('--cr-w', el.getBoundingClientRect().width + 'px'); };
      textBusy++; f.classList.add('cr-typing');
      return new Promise(function (res) {
        var i = src.length; from.style.opacity = 1; to.style.opacity = 0;
        var del = setInterval(function () {
          i--; from.textContent = src.slice(0, i); if (i > 0) from.appendChild(caret()); measure(from);
          if (i <= 0) {
            clearInterval(del); from.textContent = ''; from.style.opacity = 0; to.style.opacity = 1; to.textContent = '';
            var j = 0; var typ = setInterval(function () {
              j++; to.textContent = dst.slice(0, j); if (j < dst.length) to.appendChild(caret()); measure(to);
              if (j >= dst.length) { clearInterval(typ); to.textContent = dst; from.textContent = src; measure(to); done(); }
            }, 58);
          }
        }, 42);
        function done() { setTimeout(function () { fa.style.opacity = ''; fb.style.opacity = ''; f.classList.remove('cr-typing'); f.classList.toggle('is-b', toB); textBusy--; res(); }, 100); }
      });
    }
    function pickSwitch(f) {
      if (f && f.classList.contains('cr-flip--fit')) return runTypeFit;
      if (textBusy > 0) return runPop;
      var r = Math.random();
      return r < 0.6 ? runPop : r < 0.85 ? runType : runScramble;
    }

    /* one scheduler per group */
    function schedule(flips, maxOn, pace) {
      if (!flips.length) return;
      var busy = 0, cooldown = new Map();
      function tick() {
        if (document.visibilityState === 'visible' && busy < maxOn) {
          var now = Date.now(), pool = flips.filter(function (f) { return !f._crBusy && (cooldown.get(f) || 0) < now; });
          if (pool.length) {
            var f = pool[Math.floor(Math.random() * pool.length)], go = pickSwitch(f), back = pickSwitch(f);
            f._crBusy = true; busy++;
            go(f, true)
              .then(function () { return wait(rnd(2500, 4000)); })
              .then(function () { return back(f, false); })
              .then(function () { f._crBusy = false; busy--; cooldown.set(f, Date.now() + 9000); });
          }
        }
        setTimeout(tick, rnd(pace[0], pace[1]));
      }
      setTimeout(tick, rnd(600, 1800));
    }
    var phone = window.matchMedia('(max-width: 749px)').matches;
    var flipsIn = function (sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); };
    schedule(flipsIn('.cr-depts__list .cr-flip'), phone ? 1 : 2, [1600, 3600]);
    schedule(flipsIn('.cr-depts-grid .cr-flip'), 1, [2400, 5000]);
    schedule(flipsIn('.cr-strip__group:not([aria-hidden]) .cr-flip'), 1, [2400, 5000]);

    /* phone menu: Origin's drawer prints plain link titles, so wrap them here from the JSON map */
    var mapEl = document.getElementById('cr-nicknames'), map = null;
    try { map = mapEl && JSON.parse(mapEl.textContent); } catch (e) { map = null; }
    if (map) {
      var wallFlips = [];
      var handleOf = function (href) { var m = href && href.match(/collections\/([^/?#]+)/); return m ? m[1] : null; };
      document.querySelectorAll('.menu-drawer__menu a[href*="collections/"], .menu-drawer__menu summary').forEach(function (el) {
        var a = el.tagName === 'A' ? el : el.parentElement.querySelector('.menu-drawer__submenu a[href*="collections/"]');
        var h = a && handleOf(a.getAttribute('href')); if (!h) return;
        /* a summary's first child link is a subcategory (dept-sub); walk back to the department key */
        if (!map[h]) { h = Object.keys(map).filter(function (k) { return h.indexOf(k + '-') === 0; })[0]; if (!h) return; }
        var textNode = null;
        for (var i = 0; i < el.childNodes.length; i++) { var n = el.childNodes[i]; if (n.nodeType === 3 && n.textContent.trim()) textNode = n; }
        var host = textNode || el.querySelector('span:not([class*="icon"])'); if (!host) return;
        var title = host.textContent.trim(); if (!title) return;
        var f = document.createElement('span'); f.className = 'cr-flip'; f.setAttribute('data-alt', map[h].alt);
        var sa = document.createElement('span'); sa.className = 'cr-flip__a'; sa.textContent = title;
        var sb = document.createElement('span'); sb.className = 'cr-flip__b cr-sk cr-sk--' + map[h].sk; sb.setAttribute('aria-hidden', 'true'); sb.textContent = map[h].alt;
        f.appendChild(sa); f.appendChild(sb);
        if (textNode) { el.replaceChild(f, textNode); } else { host.textContent = ''; host.appendChild(f); }
        wallFlips.push(f);
      });
      schedule(wallFlips, 1, [1800, 3800]);
    }

    /* collection H1: same flip as the nav pills, on a slower clock. The box is sized to the visible word
       (both children are absolute) so the product-count badge stays put beside whichever word is showing. */
    var h1 = document.querySelector('.cr-colhead__title .cr-flip--fit');
    if (h1) schedule([h1], 1, [7000, 14000]); // the box is sized by initTitleFit, which also runs without motion
  }

  /* Collection H1. The fitted flip box is sized to the visible word (its children are absolute, so it has no
     width of its own), and the whole title steps its font size down until the real title and the count badge
     share one line: on phones "SPORT & OUTDOORS" filled the width and pushed the badge onto a line of its own. */
  function initTitleFit() {
    var h1 = document.querySelector('.cr-colhead__title'), flip = h1 && h1.querySelector('.cr-flip--fit');
    if (!h1 || !flip) return;
    var badge = h1.querySelector('.cr-count'), title = flip.querySelector('.cr-flip__a');
    function fit() {
      var word = flip.classList.contains('is-b') ? flip.querySelector('.cr-flip__b') : title;
      h1.style.fontSize = '';
      var size = parseFloat(getComputedStyle(h1).fontSize), avail = h1.clientWidth;
      var need = function () { return title.getBoundingClientRect().width + (badge ? badge.getBoundingClientRect().width + size * 0.4 : 0); };
      while (need() > avail && size > 24) { size = Math.max(24, size - 1); h1.style.fontSize = size + 'px'; }
      flip.style.setProperty('--cr-w', word.getBoundingClientRect().width + 'px');
    }
    fit();
    window.addEventListener('resize', fit);
    new MutationObserver(fit).observe(flip, { attributes: true, attributeFilter: ['class'] });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  /* 6. Product page sets (cart-room-8.css). The header script has already put the set on <html>;
     this wires the parts a skin cannot do in CSS: the details tabs, the two sideways strips, and the
     "goes with" bundle / tick-list adds (one /cart/add.js call with several lines, then Origin's own
     cart notification is refreshed exactly the way product-form.js does it). */
  function initPdp() {
    var html = document.documentElement;
    if (!html.hasAttribute('data-pdp-set')) return;

    // arrows that step a horizontal track by two cards
    function scroller(nav, track) {
      if (!nav || !track) return;
      nav.querySelectorAll('[data-cr-scroll]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = track.firstElementChild;
          var gap = parseFloat(getComputedStyle(track).columnGap) || 24;
          var step = card ? card.getBoundingClientRect().width + gap : 300;
          var max = track.scrollWidth - track.clientWidth;
          var to = Math.max(0, Math.min(max, Math.round(track.scrollLeft / step) * step + step * 2 * parseInt(btn.dataset.crScroll, 10)));
          track.scrollTo({ left: to, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
    }

    // format pennies the way the shop formats the sample price next to it (symbol, separators, decimals)
    // (the sample is the visible price text of a card: symbol, separators and decimals come from it, words like "From" do not)
    function moneyLike(sample, cents) {
      var m = (sample || '').match(/(\S{0,4}?)([0-9][0-9.,]*[0-9]|[0-9])(\S{0,4})/);
      if (!m) return (cents / 100).toFixed(2);
      var num = m[2], dec = /[.,][0-9]{2}$/.test(num) ? num.charAt(num.length - 3) : '';
      var thou = dec === ',' ? '.' : ',';
      var whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return m[1] + (dec ? whole + dec + ('0' + (cents % 100)).slice(-2) : whole) + m[3];
    }
    function priceText(card) { var el = card && card.querySelector('.price-item--last, .price-item--regular, .cr-card__price'); return el ? el.textContent.trim() : ''; }

    // several lines in one go, then hand the response to Origin's cart notification / drawer
    function addItems(items, btn) {
      if (!items.length || btn.classList.contains('loading')) return;
      btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true');
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: items };
      if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = location.pathname; }
      var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(url + (/\.js$/.test(url) ? '' : '.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { console.error(res.description || res.message); return; }
          if (res.items && res.items.length) res.key = res.items[0].key;
          if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id, cartData: res });
          if (cart && cart.renderContents) cart.renderContents(res);
        })
        .catch(function (e) { console.error(e); })
        .finally(function () { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); });
    }

    /* the square photo frame: a photo that is roughly square fills it (a 4:5 shot loses a thin band top and bottom); one that is
       clearly wider or taller is shown whole on white instead of being cropped to a quarter of itself. Runs on
       every photo as it loads, including the ones Origin swaps in on a variant change. Frames that already show
       the cut-out (diecut, paper) are left alone. */
    function fitPhoto(img) {
      var frame = html.dataset.pdpFrame;
      if (frame === 'diecut' || frame === 'paper') return;
      if (!img.naturalWidth || !img.naturalHeight) return;
      var ratio = img.naturalWidth / img.naturalHeight;
      img.style.objectFit = ratio > 0.66 && ratio < 1.5 ? 'cover' : 'contain'; // 4:5 / 5:4 and squarer fill; panoramas and tall crops show whole
    }
    document.querySelectorAll('product-info .product-media-container img').forEach(function (img) { if (img.complete) fitPhoto(img); });
    document.addEventListener('load', function (e) { var t = e.target; if (t && t.tagName === 'IMG' && t.closest && t.closest('product-info .product-media-container')) fitPhoto(t); }, true);

    /* details: tabs + strip */
    var det = document.querySelector('.cr-details');
    if (det) {
      var tabs = det.querySelectorAll('[data-cr-tab]'), cards = det.querySelectorAll('[data-cr-card]');
      var show = function (key) {
        tabs.forEach(function (b) { var on = b.dataset.crTab === key; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); });
        cards.forEach(function (c) { c.classList.toggle('is-on', c.dataset.crCard === key); });
      };
      tabs.forEach(function (b) { b.addEventListener('click', function () { show(b.dataset.crTab); }); });
      if (tabs.length) show(tabs[0].dataset.crTab);
      // the size-chart link in the buy box lands on the size tab when tabs are on
      document.querySelectorAll('a[href="#cr-size-chart"]').forEach(function (a) { a.addEventListener('click', function () { if (html.dataset.pdpDetails === 'tabs') show('size'); }); });
      scroller(det.querySelector('.cr-details__nav'), det.querySelector('.cr-details__grid'));
      // label skin: the words stack down the left, the data stacks down the cream right, each its own column
      if (html.dataset.pdpDetails === 'label') {
        var grid = det.querySelector('.cr-details__grid'), stacks = { a: ['desc', 'why', 'faq'], b: ['specs', 'inbox', 'size'] };
        var deliv = grid.querySelector('[data-cr-card="deliv"]');
        Object.keys(stacks).forEach(function (k) {
          var col = document.createElement('div');
          col.className = 'cr-details__stack cr-details__stack--' + k;
          stacks[k].forEach(function (key) { var c = grid.querySelector('[data-cr-card="' + key + '"]'); if (c) col.appendChild(c); });
          grid.insertBefore(col, deliv);
        });
        var firstQ = grid.querySelector('.cr-detail__faq details');
        if (firstQ) firstQ.open = true;
      }
    }

    /* goes with: recommendations arrive by fetch, so set up on every swap */
    var wrap = document.querySelector('.cr-related-wrap'), recs = wrap && wrap.querySelector('product-recommendations');
    if (!recs) return;
    var skin = html.dataset.pdpRelated;
    function setupRelated() {
      var track = recs.querySelector('.cr-related__cards');
      if (!track || track.dataset.crReady) return;
      track.dataset.crReady = '1';
      scroller(recs.querySelector('.cr-related__nav'), track);

      if (skin === 'bundle') {
        // bundle-able cards first (single variant, in stock), then this product in front and the total at the end
        track.querySelectorAll('.cr-card[data-nobundle]').forEach(function (c) { track.appendChild(c); });
        var selfT = wrap.querySelector('.cr-related__self'), totalT = wrap.querySelector('.cr-related__total');
        var self = selfT && selfT.content.querySelector('.cr-card');
        if (self) { self = self.cloneNode(true); self.classList.add('cr-card--self'); track.insertBefore(self, track.firstChild); }
        var box = totalT && totalT.content.firstElementChild;
        if (box) { box = box.cloneNode(true); track.appendChild(box); }
        // this product always goes in (its variant is read from the buy box at click time), plus the first three bundle-able picks
        var picks = (self ? [self] : []).concat(Array.prototype.slice.call(track.querySelectorAll('.cr-card:not(.cr-card--self):not([data-nobundle])'), 0, 3));
        if (box) {
          var sum = picks.reduce(function (t, c) { return t + (parseInt(c.dataset.price, 10) || 0); }, 0);
          var sample = priceText(self || picks[0]);
          box.querySelector('[data-cr-bundle-count]').textContent = picks.length;
          box.querySelector('[data-cr-bundle-total]').textContent = moneyLike(sample, sum);
          box.querySelector('[data-cr-add-bundle]').addEventListener('click', function () {
            // this product goes in as whatever the buy box has selected right now
            var chosen = document.querySelector('product-info form[data-type="add-to-cart-form"] input[name="id"]');
            addItems(picks.map(function (c) { return { id: parseInt(c === self && chosen ? chosen.value : c.dataset.variant, 10), quantity: 1 }; }), this);
          });
        }
      }

      if (skin === 'ticks') {
        var boxes = Array.prototype.slice.call(track.querySelectorAll('.cr-card__tick input:not(:disabled)'));
        var btn = recs.querySelector('[data-cr-add-ticked]'), label = btn && btn.querySelector('[data-cr-ticked-label]');
        boxes.slice(0, 2).forEach(function (b) { b.checked = true; });
        var refresh = function () {
          var on = boxes.filter(function (b) { return b.checked; });
          var sum = on.reduce(function (t, b) { return t + (parseInt(b.closest('.cr-card').dataset.price, 10) || 0); }, 0);
          var sample = on.length ? priceText(on[0].closest('.cr-card')) : '';
          if (label) label.textContent = on.length ? 'Add ticked (' + on.length + ') · ' + moneyLike(sample, sum) : 'Tick something first';
          if (btn) btn.disabled = !on.length;
        };
        boxes.forEach(function (b) { b.addEventListener('change', refresh); });
        refresh();
        if (btn) btn.addEventListener('click', function () {
          addItems(boxes.filter(function (b) { return b.checked; }).map(function (b) { return { id: parseInt(b.closest('.cr-card').dataset.variant, 10), quantity: 1 }; }), btn);
        });
      }
    }
    setupRelated();
    new MutationObserver(setupRelated).observe(recs, { childList: true });
  }

  /* 7. Join band: the arrow from the P.S. to the Join button is drawn from where the two actually are, so it
     lands on the button at any width. Beside the button it crosses the gap to the button's right edge; below
     it (phones, tablets, two-column desktops) it climbs from the note's top into the button's underside.
     Redrawn whenever the grid or its columns change size. */
  function initJoinArrow() {
    var grid = document.querySelector('.cr-join__grid');
    var arrow = grid && grid.querySelector(':scope > .cr-join__arrow');
    var btn = grid && grid.querySelector('.cr-join__form button');
    var ps = grid && grid.querySelector('.cr-join__ps');
    var shaft = arrow && arrow.querySelector('.cr-join__arrow-shaft'), head = arrow && arrow.querySelector('.cr-join__arrow-head');
    if (!grid || !arrow || !btn || !ps || !shaft || !head) return;
    var inView = reduceMotion || !('IntersectionObserver' in window);
    var f = function (n) { return n.toFixed(1); };

    function draw() {
      var g = grid.getBoundingClientRect();
      if (!g.width || !g.height) return;
      var rel = function (r) { return { l: r.left - g.left, t: r.top - g.top, r: r.right - g.left, b: r.bottom - g.top, cx: (r.left + r.right) / 2 - g.left, cy: (r.top + r.bottom) / 2 - g.top, h: r.height }; };
      var B = rel(btn.getBoundingClientRect()), P = rel(ps.getBoundingClientRect());
      arrow.setAttribute('viewBox', '0 0 ' + f(g.width) + ' ' + f(g.height));
      var s, e, c1, c2;
      if (P.l >= B.r + 40) {
        // side: from the note's left edge across the gap, bowing down a little, into the button's right edge
        s = { x: P.l - 4, y: P.t + P.h * 0.42 }; e = { x: B.r + 12, y: B.cy };
        var dx = s.x - e.x;
        c1 = { x: s.x - dx * 0.35, y: s.y + 26 }; c2 = { x: e.x + dx * 0.4, y: e.y + 30 };
      } else {
        // up: from the note's top, out to the right and up, hooking in under the button
        s = { x: Math.min(P.r - 24, B.cx + 90), y: P.t - 2 }; e = { x: B.cx, y: B.b + 10 };
        var dy = s.y - e.y;
        c1 = { x: s.x + 30, y: s.y - dy * 0.6 }; c2 = { x: e.x + 30, y: e.y + dy * 0.6 };
      }
      shaft.setAttribute('d', 'M' + f(s.x) + ' ' + f(s.y) + ' C ' + f(c1.x) + ' ' + f(c1.y) + ', ' + f(c2.x) + ' ' + f(c2.y) + ', ' + f(e.x) + ' ' + f(e.y));
      // the head follows the curve's final tangent
      var ang = Math.atan2(e.y - c2.y, e.x - c2.x), L = 16, a = Math.PI / 6;
      head.setAttribute('d', 'M' + f(e.x - L * Math.cos(ang - a)) + ' ' + f(e.y - L * Math.sin(ang - a)) + ' L' + f(e.x) + ' ' + f(e.y) + ' L' + f(e.x - L * Math.cos(ang + a)) + ' ' + f(e.y - L * Math.sin(ang + a)));
      // the shaft draws itself in the first time the band scrolls into view
      var len = shaft.getTotalLength();
      shaft.style.strokeDasharray = len;
      shaft.style.strokeDashoffset = inView ? 0 : len;
      if (inView) arrow.classList.add('is-in');
    }

    // already on screen at load: draw it settled (same rule as the stamps), otherwise wait for the scroll
    if (!inView) { var r0 = ps.getBoundingClientRect(); if (r0.top < window.innerHeight && r0.bottom > 0) inView = true; }
    draw();
    if (!inView) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (en) { return en.isIntersecting; })) return;
        inView = true; draw(); io.disconnect();
      }, { threshold: 0.3 });
      io.observe(ps);
    }
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(draw);
      [grid, btn, ps].forEach(function (el) { ro.observe(el); });
    } else {
      window.addEventListener('resize', draw);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(draw);
    window.addEventListener('load', draw);
  }

  /* 8. Product details grid: a non-wide card left alone on the last row gets .is-lone, and the tablet CSS
     spreads it across both columns. Wide cards restart the row count. */
  function initDetailsLone() {
    var grid = document.querySelector('.cr-details__grid');
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.cr-detail')) : []; // the label skin nests them in stacks
    if (!cards.length) return;
    var inRow = 0;
    cards.forEach(function (c) { c.classList.remove('is-lone'); inRow = c.classList.contains('cr-detail--wide') ? 0 : (inRow + 1) % 2; });
    var last = cards[cards.length - 1];
    if (!last.classList.contains('cr-detail--wide') && inRow === 1) last.classList.add('is-lone');
  }

  /* 9. Search page. Shopify's storefront search index still lists the ~77k products deleted on 16 Sep 2026,
     so search.results is useless (783 "polo" hits on a 331-product store, none of them live). This searches the
     live catalogue instead: /products.json is read from the product database, not the index. The catalogue is
     slimmed to what a card needs and kept in sessionStorage for 15 minutes; results are the same sticker cards
     as the collection grid. */
  function initSearch() {
    var root = document.querySelector('[data-cr-search]');
    if (!root) return;
    var results = root.querySelector('[data-cr-search-results]'), status = root.querySelector('[data-cr-search-status]');
    var empty = root.querySelector('[data-cr-search-empty]'), emptyTitle = root.querySelector('[data-cr-search-empty-title]');
    var more = root.querySelector('[data-cr-search-more]'), moreBtn = more && more.querySelector('button');
    var sortForm = root.querySelector('[data-cr-search-sortform]'), sortSel = root.querySelector('[data-cr-search-sort]');
    var title = document.querySelector('[data-cr-search-title]'), count = document.querySelector('[data-cr-search-count]');
    var form = document.querySelector('[data-cr-search-form]'), input = form && form.querySelector('input[name="q"]');
    var money = root.dataset.money || '£1.00', shopName = root.dataset.shop || '', pageSize = parseInt(root.dataset.limit, 10) || 24;
    var KEY = 'cr_catalogue_v1', TTL = 15 * 60 * 1000, PAGE = 250, MAX_PAGES = 40;
    var catalogue = null, matches = [], shown = 0, sort = 'relevance', q = root.dataset.q || '';

    function fmt(n) { var v = Number(n).toFixed(2); return money.replace('1.00', v).replace('1,00', v.replace('.', ',')); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function img(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
    function text(html) { return String(html || '').replace(/<[^>]+>/g, ' ').replace(/&[a-z#0-9]+;/gi, ' ').replace(/\s+/g, ' ').trim(); }

    // one product → the little it takes to search it and draw a card
    function slim(p) {
      var vs = p.variants || [], avail = vs.filter(function (v) { return v.available; });
      var prices = vs.map(function (v) { return parseFloat(v.price); }).filter(function (n) { return !isNaN(n); });
      var first = avail[0] || vs[0] || {};
      var cmp = parseFloat(first.compare_at_price) || 0, price = parseFloat(first.price) || Math.min.apply(null, prices) || 0;
      return {
        id: p.id, t: p.title || '', h: p.handle, v: p.vendor || '', ty: p.product_type || '',
        tg: (p.tags || []).join(' '), b: text(p.body_html).slice(0, 400),
        p: price, from: prices.length > 1 && Math.min.apply(null, prices) < Math.max.apply(null, prices), c: cmp > price ? cmp : 0,
        a: avail.length > 0, one: vs.length === 1, vid: first.id, img: p.images && p.images[0] ? p.images[0].src : '', img2: p.images && p.images[1] ? p.images[1].src : '',
        d: Date.parse(p.created_at || 0) || 0
      };
    }

    function load() {
      try {
        var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (c && c.t && Date.now() - c.t < TTL && c.items && c.items.length) return Promise.resolve(c.items);
      } catch (e) {}
      var items = [];
      function page(n) {
        return fetch('/products.json?limit=' + PAGE + '&page=' + n, { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('products.json ' + r.status);
          return r.json();
        }).then(function (j) {
          var got = (j && j.products) || [];
          got.forEach(function (p) { items.push(slim(p)); });
          if (got.length < PAGE || n >= MAX_PAGES) return items;
          return page(n + 1);
        });
      }
      return page(1).then(function (list) {
        try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), items: list })); } catch (e) {}
        return list;
      });
    }

    // every term must land somewhere; where it lands sets the score (title first, then tags, type and maker, then the blurb)
    function score(item, terms) {
      var t = item.t.toLowerCase(), tg = item.tg.toLowerCase(), ty = (item.ty + ' ' + item.v).toLowerCase(), b = item.b.toLowerCase();
      var s = 0;
      for (var i = 0; i < terms.length; i++) {
        var w = terms[i], hit = 0, at = t.indexOf(w);
        if (at > -1) { hit += 6; if (at === 0 || /[^a-z0-9]/.test(t.charAt(at - 1))) hit += 2; if (at === 0) hit += 1; }
        if (tg.indexOf(w) > -1) hit += 3;
        if (ty.indexOf(w) > -1) hit += 2;
        if (b.indexOf(w) > -1) hit += 1;
        if (!hit) return 0;
        s += hit;
      }
      if (terms.length > 1 && t.indexOf(terms.join(' ')) > -1) s += 4; // the whole phrase in the title
      if (!item.a) s -= 3; // sold out sinks a little
      return s;
    }

    function run() {
      var terms = q.toLowerCase().replace(/[^\p{L}\p{N}\s'-]/gu, ' ').split(/\s+/).filter(function (w) { return w.length > 1 || /\p{N}/u.test(w); });
      if (!terms.length) { matches = []; render(true); return; }
      matches = catalogue.map(function (it) { return { it: it, s: score(it, terms) }; }).filter(function (m) { return m.s > 0; });
      applySort();
      render(false);
    }

    function applySort() {
      var by = {
        'relevance': function (a, b) { return b.s - a.s || (b.it.a - a.it.a) || b.it.d - a.it.d; },
        'price-ascending': function (a, b) { return a.it.p - b.it.p; },
        'price-descending': function (a, b) { return b.it.p - a.it.p; },
        'created-descending': function (a, b) { return b.it.d - a.it.d; },
        'title-ascending': function (a, b) { return a.it.t.localeCompare(b.it.t); }
      }[sort] || function () { return 0; };
      matches.sort(by);
    }

    function card(it) {
      var url = '/products/' + it.h, sale = it.c > 0 ? Math.round((it.c - it.p) * 100 / it.c) : 0, fresh = Date.now() - it.d < 30 * 86400000;
      var badge = !it.a ? '<span class="cr-card__badge cr-card__badge--out">Sold out</span>' : sale > 0 ? '<span class="cr-card__badge">Save ' + sale + '%</span>' : '';
      var stamp = it.tg.toLowerCase().split(' ').indexOf('tested') > -1 ? '<span class="cr-card__stamp" aria-hidden="true">Tested</span>' : (fresh && !sale && it.a ? '<span class="cr-card__stamp cr-card__stamp--new" aria-hidden="true">New</span>' : '');
      var price = it.c > 0
        ? '<div class="price price--on-sale"><div class="price__container"><div class="price__regular"><span class="price-item price-item--regular">' + fmt(it.c) + '</span></div><div class="price__sale"><span class="price-item price-item--sale price-item--last">' + fmt(it.p) + '</span></div></div></div>'
        : '<div class="price"><div class="price__container"><div class="price__regular"><span class="price-item price-item--regular">' + (it.from ? 'From ' : '') + fmt(it.p) + '</span></div></div></div>';
      var buy = it.one
        ? '<product-form><form method="post" action="/cart/add" class="cr-card__form" data-type="add-to-cart-form" novalidate="novalidate"><input type="hidden" name="id" value="' + it.vid + '"><button type="submit" name="add" class="cr-btn cr-btn--yellow product-form__submit cr-card__btn"' + (it.a ? '' : ' disabled') + '><span>' + (it.a ? 'Add to basket' : 'Sold out') + '</span><div class="loading__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></button><input type="hidden" name="product-id" value="' + it.id + '"></form></product-form>'
        : '<div class="cr-card__form"><a href="' + url + '" class="cr-btn cr-btn--yellow cr-card__btn">Choose options</a></div>';
      return '<div class="cr-sticker cr-card" data-price="' + Math.round(it.p * 100) + '" data-variant="' + it.vid + '"' + (it.a && it.one ? '' : ' data-nobundle') + '>' +
        '<span class="cr-card__tape" aria-hidden="true"></span>' +
        '<a href="' + url + '" class="cr-card__media" aria-label="' + esc(it.t) + '">' +
          (it.img ? '<img src="' + esc(img(it.img, 600)) + '" srcset="' + esc(img(it.img, 300)) + ' 300w, ' + esc(img(it.img, 450)) + ' 450w, ' + esc(img(it.img, 600)) + ' 600w" sizes="(min-width: 990px) 280px, 45vw" loading="lazy" alt="' + esc(it.t) + '">' : '') +
          (it.img2 ? '<img src="' + esc(img(it.img2, 600)) + '" loading="lazy" alt="" class="cr-card__img--alt">' : '') +
          badge + stamp +
        '</a>' +
        '<div class="cr-card__info">' +
          (it.v && it.v !== shopName ? '<div class="cr-card__dept">' + esc(it.v) + '</div>' : '') +
          '<h3 class="cr-card__title"><a href="' + url + '">' + esc(it.t) + '</a></h3>' +
          '<div class="cr-card__price">' + price + '</div>' +
          buy +
        '</div>' +
      '</div>';
    }

    function render(blank) {
      var n = matches.length, label = q ? '“' + q + '”' : '';
      if (title) title.innerHTML = q ? '&ldquo;' + esc(q) + '&rdquo;' : esc(title.getAttribute('data-default') || 'Search the room');
      if (count) { count.textContent = n; count.hidden = !q; }
      if (blank) {
        status.textContent = 'Type something up there';
        results.innerHTML = ''; empty.hidden = true; more.hidden = true; sortForm.hidden = true;
        return;
      }
      status.textContent = n === 0 ? 'Nothing on the shelf for ' + label : n === 1 ? '1 thing for ' + label : n + ' things for ' + label;
      sortForm.hidden = n < 2;
      if (!n) {
        results.innerHTML = ''; more.hidden = true;
        if (emptyTitle) emptyTitle.textContent = 'Nothing for ' + label + '.';
        empty.hidden = false;
        return;
      }
      empty.hidden = true;
      shown = Math.min(pageSize, n);
      results.innerHTML = matches.slice(0, shown).map(function (m) { return card(m.it); }).join('');
      more.hidden = shown >= n;
      document.title = label + ' – ' + n + ' things';
    }

    if (moreBtn) moreBtn.addEventListener('click', function () {
      var next = Math.min(shown + pageSize, matches.length);
      results.insertAdjacentHTML('beforeend', matches.slice(shown, next).map(function (m) { return card(m.it); }).join(''));
      shown = next; more.hidden = shown >= matches.length;
    });
    if (sortSel) sortSel.addEventListener('change', function () { sort = sortSel.value; applySort(); render(false); });
    if (form) form.addEventListener('submit', function (e) {
      if (!catalogue) return; // not loaded yet: let the page reload do it
      e.preventDefault();
      q = (input.value || '').trim();
      try { history.replaceState(null, '', q ? '?q=' + encodeURIComponent(q) : location.pathname); } catch (err) {}
      run();
    });
    if (title) title.setAttribute('data-default', title.textContent);

    load().then(function (list) {
      catalogue = list;
      run();
    }).catch(function () {
      status.textContent = 'Search is having a moment';
      if (emptyTitle) emptyTitle.textContent = 'Could not load the shelves.';
      empty.hidden = false; more.hidden = true;
    });
  }

  /* Deal of the day: the product name steps its size down until it fits on two lines at most, whatever the
     layout set or screen, so a long name never pushes the card out of shape. Re-checked on resize. */
  function initDealTitleFit() {
    var titles = document.querySelectorAll('.cr-dl__title');
    if (!titles.length) return;
    function lines(el) { var a = el.querySelector('a') || el, r = a.getClientRects(); return r.length || 1; }
    function fit(el) {
      el.style.fontSize = '';
      var size = parseFloat(getComputedStyle(el).fontSize);
      while (lines(el) > 2 && size > 15) { size -= 1; el.style.fontSize = size + 'px'; }
    }
    function all() { titles.forEach(fit); }
    all();
    window.addEventListener('resize', all);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(all);
  }

  /* Deal tag lines: when there is no real stock count the red tag carries the section's lines and turns them
     over every few seconds, shake-and-pop like the department nicknames. Only the card on screen runs. */
  function initDealLines() {
    var tags = document.querySelectorAll('.cr-dl__stock[data-cr-lines]');
    if (!tags.length) return;
    function rnd(lo, hi) { return lo + Math.random() * (hi - lo); }
    tags.forEach(function (tag) {
      var lines = tag.getAttribute('data-cr-lines').split('|').filter(Boolean);
      if (lines.length < 2) return;
      var i = 0;
      function next() { var n; do { n = Math.floor(Math.random() * lines.length); } while (n === i); i = n; return lines[n]; }
      function shown() { return tag.getClientRects().length > 0 && document.visibilityState === 'visible'; }
      function turn() {
        if (!shown()) { setTimeout(turn, 1500); return; }
        if (reduceMotion) { tag.textContent = next(); setTimeout(turn, rnd(4000, 6000)); return; }
        tag.classList.remove('is-in'); tag.classList.add('is-out');
        setTimeout(function () {
          tag.textContent = next();
          tag.classList.remove('is-out'); tag.classList.add('is-in');
          setTimeout(turn, rnd(3500, 5500));
        }, 450);
      }
      setTimeout(turn, rnd(3000, 5000));
    });
  }

  function start() { initMascot(); initBasketBump(); initStamps(); initTimerTicks(); initTitleFit(); initNicknames(); initPdp(); initJoinArrow(); initDetailsLone(); initSearch(); initDealTitleFit(); initDealLines(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
